import React from "react";
import "./TemplateCaja.css";

import HeaderPasos from "../../../componentsUI/estructura/headerPasos/headerPasos.js";

// Formularios

import FormularioCierreCaja from "../cierre/formCierre.js";
import FormularioAperturaCaja  from "../apertura/formApertura.js";
import ListaSesionesCaja from "../listaSesiones/listarSesiones.js";

const pasosCaja = [
  
  {
    id: "apertura",
    label: "Apertura",
    component: <FormularioAperturaCaja />,
  },

    {
    id: "cierre",
    label: "Cierre",
    component: <FormularioCierreCaja />,
  }  ,{
    id: "sesiones",
    label: "Sesiones",
    component: <ListaSesionesCaja />,
  },

];

export default function TemplateCaja() {
  return (
    <HeaderPasos
      titulo="Caja"
      pasos={pasosCaja}
      pasoInicial="sesiones"
    />
  );
}
